import { render } from "./SchedaFrate.vue?vue&type=template&id=55a689fd"
import script from "./SchedaFrate.vue?vue&type=script&lang=js"
export * from "./SchedaFrate.vue?vue&type=script&lang=js"

import "./SchedaFrate.vue?vue&type=style&index=0&id=55a689fd&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__